import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import AutoComp from '../components/AutoComp'
import NavBar from '../components/NavBar'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import { mCPF, mCEP, mTel, mCNPJ } from '../utils/masks'
import { colors } from '../utils/vars'
import FrDatePicker from '../components/FrDatePicker'
import consultaCep from '../services/consultaCep'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel';

import api from '../services/api'
import { getAge, paramsToObject, getUserCode } from '../utils/functions'

import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';
import { validarCNPJ, validarCPF } from '../utils/functions';
import moment from 'moment'
import { Icon } from 'react-icons-kit'
import { ic_search } from 'react-icons-kit/md/ic_search'
import ClientesModal from './Clientes'
import Dialog from '@material-ui/core/Dialog';


const swal = withReactContent(Swal)

function Clientes(props) {
  const [data, setData] = useState({ tipo: 11 })
  const [updateType, setUpdateType] = useState(false)
  const [responsavel, setResponsavel] = useState('')
  const [enableEdit, setEnableEdit] = useState('N')
  const [dependentes, setDependentes] = useState(false)
  const [comboCid, setComboCid] = useState([{ value: '', display: '' }])
  const [comboSexo, setComboSexo] = useState([{ value: 'F', display: 'Feminino' }, { value: 'M', display: 'Masculino' }])
  const [comboCli, setComboCli] = useState([{ value: '', display: '' }])
  const [comboRep, setComboRep] = useState([{ value: '', display: '' }])
  const [representante, setRepresentante] = useState('')
  const [invalido, setInvalido] = useState(false)
  const [duplicado, setDuplicado] = useState(false)
  const [comboOri, setComboOri] = useState([{ value: '', display: '' }])
  const [comboSub, setComboSub] = useState([{ value: '', display: '' }])
  const [disableEdit, setdisableEdit] = useState(false)
  const [showModalCliente, setShowModalCliente] = useState(false)
  const [nomeCli, setNomeCli] = useState('')
  const [pk_cli, setPk_Cli] = useState('')
  const [titulo, setTitulo] = useState('Clientes')
  const [criouResponsavel, setCriouResponsavel] = useState(false)
  const [erroCep, setErroCep] = useState(false)
  
  useEffect(() => {
    const ajustaTitulo = () => {
      console.log(props.responsavel)
      if (dependentes) {
        setTitulo('Clientes/Dependentes')
      } else if (props.responsavel) {
        setTitulo ('Responsável')
      } 
    }
    ajustaTitulo()
  }, [dependentes])
  useEffect(() => {
    

    const fetchData = async () => {
      swal.fire({
        customClass: {
          container: 'my-swal'
        },

        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      setDependentes(window.location.href.indexOf('dependentes') !== -1)
      let codigo = props.pk_cli ? props.pk_cli : query.codigo
      setComboCid(await api.getComboData('cidades'))
      setComboRep(await api.getComboData('representantes'))
      setComboCli(await api.getComboData('clientes'))
      setComboOri(await api.getComboData('origens_contatos'))
      setComboSub(await api.getComboData('sub_origem'))

      if (codigo > 0) {
        setEnableEdit(await api.getAcessos('Clientes', 'Alteracao'))
      } else {
        setEnableEdit(await api.getAcessos('Clientes', 'Inclusao'))
      }


      if (codigo > 0) {
        setUpdateType(true)
        api.get('/clientes?pk_cli=' + codigo).then(async r => {
          if (r.data[0]) {
            let auxValues = { ...r.data[0] }
            setComboCli(await api.getComboDataWhere('clientes', "?nome=" + r.data[0].nome_responsavel))
            setComboRep(await api.getComboDataWhere('representantes', "?nome=" + r.data[0].nomerep))

            if (r.data[0].diasCadastro <= 30)
              setdisableEdit(true)

            if (r.data[0].tipo > 14) {
              auxValues.cpf = mCNPJ(r.data[0].cpf)
            } else {
              auxValues.cpf = mCPF(r.data[0].cpf)
            }
            setData(auxValues)
            swal.close()
          } else {
            swal.fire({
              customClass: {
                container: 'my-swal'
              },
              title: `<h2 style='color: ${colors.info900}'>Código inválido</h2>`,
              html: `<p style='color: ${colors.info900}'>Código informado não encontrado!</p>`,
              icon: 'warning',
            }).then((result) => {
              if (result.value) {
                if (props.modal)
                  props.setShowModal(false)
                else
                  window.history.back()
              }
            })
          }
        })
      } else swal.close()
    }

    fetchData()
  }, [])


  useEffect(() => {
    const fetchData = async () => {
      const auxValues = { ...data };
      auxValues.cod_responsavel = responsavel
      auxValues.nome_responsavel = ''
      api.get('/clientes?pk_cli=' + responsavel).then(async r => {
        if (r.data[0]){
          auxValues.nome_responsavel = r.data[0].nome
          auxValues.bairro = r.data[0].bairro
          auxValues.numero = r.data[0].numero
          auxValues.endereco = r.data[0].endereco
          auxValues.fk_cid = r.data[0].fk_cid
          auxValues.complemento = r.data[0].complemento
          auxValues.fone1 = r.data[0].fone1
          auxValues.fone2 = r.data[0].fone2
          auxValues.email = r.data[0].email
          auxValues.cep = r.data[0].cep
          console.log(r.data[0])
        }
        setData(auxValues)
      })
    }

    fetchData()
  }, [responsavel])

  useEffect(() => {
    const fetchData = async () => {
      const auxValues = { ...data };
      auxValues.fk_rep = representante
      auxValues.nomerep = ''
      api.get('/representantes?pk_rep=' + representante).then(async r => {
        if (r.data[0])
          auxValues.nomerep = r.data[0].nome
        setData(auxValues)
      })
    }

    fetchData()
  }, [representante])

  useEffect(() => {
    const fetchData = async () => {

      swal.fire({
        customClass: {
          container: 'my-swal'
        },

        html: <FrLoading text="Carregando sub_origem..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      setComboSub(await api.getComboDataWhere('sub_origem', "?fk_ori=" + data.fk_ori))

      swal.close()
    }
    if (data.fk_ori > 0)
      fetchData()
  }, [data.fk_ori])


  async function consistData(data) {
    let required = props.modal ? 
        [
          'nome',
          'cpf',
          'genero',
          'data_nascimento',
        ]
      :
    
        [
          'nome',
          'cpf',
          'cod_responsavel',
          'genero',
          'cep',
          'endereco',
          'numero',
          'bairro',
          'fk_cid',
          'data_nascimento',
          'fk_rep',
          'fk_ori',
        ]

    let errors = []
    if (!props.modal && data.pk_ori){
      let obrigaJustificativa = await api.get('origens_contatos?pk_ori='+ data.pk_ori)
      console.log(obrigaJustificativa)
      if (obrigaJustificativa.data[0].exige_sub == 'S')
        required.push('fk_sub')

    }
    required.forEach((curr, index) => {
      let fieldName = curr
      if (fieldName == 'cod_responsavel') {
        if (getAge(data.data_nascimento) < 18)
          fieldName = 'responsável'
        else
          fieldName = ''
      }
      if (fieldName == 'fk_sub') {
        fieldName = 'sub origem'
      }
      if (fieldName == 'fk_ori') {
        fieldName = 'origem'
      }
      if (fieldName == 'data_nascimento') {
        fieldName = 'data nascimento'
      }
      if (fieldName == 'fk_rep') {
        fieldName = 'representante'
      }
      if (fieldName == 'fk_cid') {
        fieldName = 'cidade'
      }


      if ((!data[curr]) && (fieldName !== '')) return errors.push(fieldName)
    })

    return errors
  }


  function handleSubmit(e) {
    e.preventDefault();

    swal.fire({
      customClass: {
        container: 'my-swal'
      },

      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color:${colors.info900}'>Deseja salvar ${updateType ? 'as alterações' : 'a inclusão'} do registro?</p>`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then(async (result) => {
      if (result.value) {
        const auxValues = { ...data };
        auxValues.fk_usu = getUserCode()
        auxValues.criouResponsavel = criouResponsavel
        let errors = await consistData(auxValues, e)
        console.log(errors)
        if (errors.length === 0 && !erroCep) {
          console.log('oi')
          if (updateType) {
            api.post('/clientes/edit', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  customClass: {
                    container: 'my-swal'
                  },

                  title: `<h2 style='color: ${colors.info900}'>Registro Alterado<h2>`,
                  html: `<p style='color: ${colors.info900}'>O registro foi alterado com sucesso!</p>`,
                  icon: 'success',
                }).then((result) => {
                  if (result) {
                    if (props.modal) {
                      props.setShowModal(false)
                    } else
                      window.history.back()
                  }
                })
              } else {
                swal.fire({
                  customClass: {
                    container: 'my-swal'
                  },

                  title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                  html: `<p style='color: ${colors.info900}'></p>`,
                  icon: 'warning',
                })
              }
            })
          } else {
            if (duplicado) {
              return swal.fire({
                customClass: {
                  container: 'my-swal'
                },
  
                title: `<h2 style='color: ${colors.info900}'>Documento duplicado!</h2>`,
                html: <p style={{ color: colors.info900 }}>CPF já cadastrado.</p>,
                icon: 'warning',
              }).then(() => {
                
              })
            } else {

              try {
                api.post('/clientes/add', auxValues).then(r => {
                  if (r.status === 200) {
                    let cliente = r.data
                    console.log(cliente)
                    swal.fire({
                      customClass: {
                        container: 'my-swal'
                      },
  
                      title: `<p style='color:${colors.info900}'Registro Adicionado</p>`,
                      html: `<p style='color: ${colors.info900}'>O registro foi adicionado com sucesso!</p>`,
                      icon: 'success',
                    }).then((result) => {
                      if (result) {
                        console.log(props.modal)
                        if (props.setPk_Cli){
                          console.log(r.data)
                          props.setPk_Cli(r.data)
                        }
                        if (props.modal) {
                          props.setNome(data.nome)
                          props.setShowModal(false)
                          props.setCriouResponsavel(true)
                        } else {
  
                          swal.fire({
                            customClass: {
                              container: 'my-swal'
                            },
  
                            title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
                            html: `<p style='color:${colors.info900}'>Deseja incluir um contrato?</p>`,
                            icon: 'question',
                            showCancelButton: true,
                            confirmButtonColor: colors.success500,
                            cancelButtonColor: colors.danger500,
                            confirmButtonText: 'Sim',
                            cancelButtonText: 'Não'
                          }).then((result) => {
                            if (result.value) {
                              window.location.href = '/salute/contratos/registro?fk_cli=' + cliente
                            } else
                              window.history.back()
                          })
                        }
                      }
                    })
  
  
                  } else {
                    swal.fire({
                      customClass: {
                        container: 'my-swal'
                      },
  
                      title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                      text: "O registro não foi adicionado!",
                      icon: 'warning',
                    })
                  }
                })
              } catch {
                swal.fire({
                  customClass: {
                    container: 'my-swal'
                  },
  
                  title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                  text: "O registro não foi adicionado!",
                  icon: 'warning',
                })
  
              }
            }

          }
        } else {
          if (errors.length > 0) {
            swal.fire({
              customClass: {
                container: 'my-swal'
              },

              title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
              html: <p style={{ color: colors.info900 }}>Verifique {errors.length > 1 ? 'os campos' : 'o campo'} {errors.join(', ')}</p>,
              icon: 'warning',
            })

          } else if (invalido) {
            swal.fire({
              customClass: {
                container: 'my-swal'
              },

              title: `<h2 style='color: ${colors.info900}'>Documento inválido!</h2>`,
              html: <p style={{ color: colors.info900 }}>Verifique o CPF/CNPJ</p>,
              icon: 'warning',
            })
          } else if (erroCep) {
            swal.fire({
              customClass: {
                container: 'my-swal'
              },
  
              title: `<h2 style='color: ${colors.info900}'>ATENÇÃO!</h2>`,
              html: `<p style='color: ${colors.info900}'>CEP Inválido</p>`,
              icon: 'warning',
            })
          }
        }
      }
    })
  }

  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      customClass: {
        container: 'my-swal'
      },

      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color: ${colors.info900}'>Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?<p>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result) {
        if (props.modal)
          props.setShowModal(false)
        else
          window.history.back()
      }
    })
  }

  const handleChange = (e) => {
    const auxValues = { ...data };
    switch (e.target.name) {
      case 'tipo_cpf': auxValues.tipo = auxValues.tipo > 11 ? 11 : 14
        break

      case 'tipo_cnpj': auxValues.tipo = auxValues.tipo <= 11 ? 14 : 11
        break

      case 'bloqueado_marketing': auxValues.bloqueado_marketing = auxValues.bloqueado_marketing == 'S' ? 'N' : 'S'
        break

      

      case 'nome': auxValues[e.target.name] = e.target.value.toUpperCase();
        if (props.modal)
          props.setNome(e.target.value)
        break

      default: auxValues[e.target.name] = e.target.value.toUpperCase();

    }
    setData(auxValues);
  };

  const handleCep = (e) => {
    e.preventDefault()
    const auxValues = { ...data };
    swal.fire({
      customClass: {
        container: 'my-swal'
      },
      html: <FrLoading text="Carregando..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    setErroCep(false)
    if (e.target.name == 'cep') {
      consultaCep((e.target.value).replace('.', '').replace('-', '') + '/json').then(r => {
        if (!r.data.erro) {
          auxValues.endereco = r.data.logradouro
          auxValues.complemento = r.data.complemento
          auxValues.bairro = r.data.bairro
          api.get('/cidades?descricao=' + r.data.localidade).then(res => {
            if (res.data.length > 0) {
              auxValues.fk_cid = res.data[0].pk_cid
            }
            setData(auxValues)
            swal.close()
          })
        } else {
          setErroCep(true)
          swal.fire({
            customClass: {
              container: 'my-swal'
            },

            title: `<h2 style='color: ${colors.info900}'>ATENÇÃO!</h2>`,
            html: `<p style='color: ${colors.info900}'>CEP Inválido</p>`,
            icon: 'warning',
          })
        }
      })

    }
  }

  const validaCpfCnpj = (e) => {
    e.preventDefault()
    e.stopPropagation()
    let value = e.target.value
    let name = e.target.name
    setInvalido(false)
    console.log(data.tipo, data.cpf.lengt, value)
    if (e.target.name == 'cpf' && data.tipo <= 14) {
      if ((value) && (!validarCPF(value))) {
        return swal.fire({
          customClass: {
            container: 'my-swal'
          },

          title: `<h2 style='color: ${colors.info900}'>ATENÇÃO!</h2>`,
          html: `<p style='color: ${colors.info900}'>CPF Inválido</p>`,
          icon: 'warning',
        }).then(r => {
          setInvalido(true)
          document.getElementById('cpf').focus()
        })
      }
    } else if (e.target.name == 'cpf' && data.tipo > 14) {
      if (!validarCNPJ(value)) {
        return swal.fire({
          customClass: {
            container: 'my-swal'
          },
          title: `<h2 style='color: ${colors.info900}'>ATENÇÃO!</h2>`,
          html: `<p style='color: ${colors.info900}'>CNPJ Inválido</p>`,
          icon: 'warning',
        }).then(r => {
          setInvalido(true)
          document.getElementById('cpf').focus()
        })
      }
    }
    if (data.cpf && data.cpf.length > 10 && !updateType) {
      api.get('/clientes?cpf=' + data.cpf).then(r => {
        console.log(r.data)
        if (r.data.length > 0){
          return swal.fire({
            customClass: {
              container: 'my-swal'
            },
            title: `<h2 style='color: ${colors.info900}'>ATENÇÃO!</h2>`,
            html: `<p style='color: ${colors.info900}'>CPF Já cadastrado na base de dados</p>`,
            icon: 'warning',
          }).then(r => {
            setDuplicado(true)
            
          })
        }
      })
    }
    if (e.target.name == 'nome' && data.nome && data.data_nascimento && !updateType) {
      api.get('/clientes?nome=' + data.nome + '&data_nascimento='+data.data_nascimento).then(r => {
        console.log(r.data)
        if (r.data.length > 0){                         
          return swal.fire({
            customClass: {
              container: 'my-swal'
            },
            title: `<h2 style='color: ${colors.info900}'>ATENÇÃO!</h2>`,
            html: `<p style='color: ${colors.info900}'>Registro duplicado</p>`,
            icon: 'warning',
          }).then(r => {
            setDuplicado(true)
          })
        }
      })
    }
  }

  function mostraModalCliente(e) {
    e.preventDefault();
    setShowModalCliente(true)
  }

  useEffect(() => {
    const atualizaCombo = async () => {
      // alert('contratos pk_cli:' + pk_cli)
      if (nomeCli != '') {
        console.log(pk_cli)
        const auxValues = { ...data };
        auxValues.nome_responsavel = nomeCli
        auxValues.cod_responsavel = pk_cli
        setData(auxValues)
      } 
      if (pk_cli > 0)
        setResponsavel(pk_cli)
    }
    atualizaCombo()
  }, [nomeCli, pk_cli])

  return (
    <div className="defaultReg">
      {!props.modal ? <NavBar /> : <></>}
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>{updateType ? 'Edição' : 'Inclusão'} de {titulo}</h3>
          <h3>Cadastrado em: <strong>{moment(data.data_cad).format("DD/MM/YYYY")}</strong>Atualizado em:
            <strong>{data.data_up ? moment(data.data_up).format("DD/MM/YYYY HH:mm") : ''}</strong></h3>

          {!props.modal ? <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} /> : <></>}
        </div>
        <br />

        <form id="regForm" onSubmit={handleSubmit}>
          <FrTextInput
            maxLength='18'
            value={data.tipo > 14 ? mCNPJ(data.cpf) : mCPF(data.cpf)}
            onChange={handleChange}
            name="cpf"
            id="cpf"
            color="#389492"
            label={data.tipo > 14 ? "CNPJ" : "CPF"}
            variant="outlined"
            size="small"
            onBlur={validaCpfCnpj}
            required
            style={{ width: 160 }}
            autoFocus
          />

          <FrTextInput
            maxLength='100'
            value={data.nome || ''}
            onChange={handleChange}
            onBlur={validaCpfCnpj}
            name="nome"
            id="nome"
            color="#389492"
            label={data.tipo > 14 ? 'Nome Fantasia' : "Nome"}
            variant="outlined"
            size="small"
            required
            style={{ width: 420 }}
          />

          <FrSelect
            value={data.genero || ''}
            onChange={handleChange}
            name="genero"
            id="genero"
            label='Sexo *'
            data={comboSexo}
            style={{ width: 120 }}
          />
          <br />
          <FrDatePicker
            name="data_nascimento"
            id="data_nascimento"
            color="#389492"
            label="Data de Nascimento *"
            variant="outlined"
            size="small"
            onBlur={validaCpfCnpj}
            style={{ width: 180 }}
            value={(data.data_nascimento || '').split("T")[0]}
            onChange={handleChange}
          />
          <FrTextInput
            maxLength='20'
            value={data.rg || ''}
            onChange={handleChange}
            name="rg"
            id="rg"
            color="#389492"
            label="RG"
            variant="outlined"
            size="small"
            style={{ width: 270 }}
            hidden={props.modal}
          />

          

          <br />


          <AutoComp
            value={data.nome_responsavel || ""}
            valor={responsavel}
            width={425}
            name="nome_responsavel"
            id="nome_responsavel"
            label='Responsável'
            data={comboCli}
            setValue={setResponsavel}
            tabela={'clientes'}
            chave={'nome'}
            disabled={disableEdit}
            hidden={props.modal}
          />
          <button hidden={disableEdit || props.modal} className="buttonF2" style={{ height: '30px', width: '35px', borderRadius: '4px' }} onClick={mostraModalCliente}>
            <Icon icon={ic_search} size={20} />
          </button>

          <br />

          <FrTextInput
            maxLength='10'
            value={data.cep ? mCEP(data.cep) : ''}
            onChange={handleChange}
            name="cep"
            id="cep"
            color="#389492"
            label="CEP"
            variant="outlined"
            size="small"
            onBlur={handleCep}
            required
            style={{ width: 110 }}
            hidden={props.modal}
          />

          <FrTextInput
            maxLength='100'
            value={data.endereco || ''}
            onChange={handleChange}
            name="endereco"
            id="endereco"
            color="#389492"
            label="Endereço"
            variant="outlined"
            size="small"
            required
            style={{ width: 450 }}
            hidden={props.modal}
          />

          <FrTextInput
            maxLength='5'
            value={data.numero || ''}
            onChange={handleChange}
            name="numero"
            id="numero"
            color="#389492"
            label="Número"
            variant="outlined"
            size="small"
            required
            style={{ width: 100 }}
            hidden={props.modal}
          />

          <FrTextInput
            maxLength='20'
            value={data.complemento || ''}
            onChange={handleChange}
            name="complemento"
            id="complemento"
            color="#389492"
            label="Complemento"
            variant="outlined"
            size="small"
            style={{ width: 120 }}
            hidden={props.modal}
          />
          <FrTextInput
            maxLength='100'
            value={data.bairro || ''}
            onChange={handleChange}
            name="bairro"
            id="bairro"
            color="#389492"
            label="Bairro"
            variant="outlined"
            size="small"
            required
            style={{ width: 250 }}
            hidden={props.modal}
          />

          <FrSelect
            value={data.fk_cid || ''}
            onChange={handleChange}
            name="fk_cid"
            id="fk_cid"
            label='Cidade *'
            data={comboCid}
            style={{ width: 200 }}
            hidden={props.modal}
          />

          <FrTextInput
            maxLength='14'
            value={data.fone1 ? mTel(data.fone1) : ''}
            onChange={handleChange}
            name="fone1"
            id="fone1"
            color="#389492"
            label="Fone 1"
            variant="outlined"
            size="small"
            style={{ width: 180 }}
            hidden={props.modal}
          />

          <FrTextInput
            maxLength='14'
            value={data.fone2 ? mTel(data.fone2) : ''}
            onChange={handleChange}
            name="fone2"
            id="fone2"
            color="#389492"
            label="Fone 2"
            variant="outlined"
            size="small"
            style={{ width: 180 }}
            hidden={props.modal}
          />

          
          <br />


          <FrTextInput
            maxLength='100'
            value={data.email || ''}
            onChange={handleChange}
            name="email"
            id="email"
            color="#389492"
            label="E-mail"
            variant="outlined"
            size="small"
            style={{ width: 270 }}
            hidden={props.modal}
          />

          <AutoComp
            value={data.nomerep || ""}
            valor={representante}
            width={425}
            name="nomerep"
            id="nomerep"
            label='Representante *'
            data={comboRep}
            setValue={setRepresentante}
            tabela={'representantes'}
            chave={'nome'}
            hidden={props.modal}

          />
          <FrTextInput
            maxLength='100'
            value={data.desconto || ''}
            onChange={handleChange}
            name="desconto"
            id="desconto"
            color="#389492"
            label="% Desconto"
            variant="outlined"
            size="small"
            style={{ width: 100 }}
            hidden={props.modal}
          />

          <FormControlLabel
            control={
              <Checkbox
                name='bloqueado_marketing'
                id='bloqueado_marketing'
                size='small'
                color="primary"
                onChange={handleChange}
                checked={data.bloqueado_marketing == 'S'}
              />
            }
            label={'Bloqueado Marketing'}
            hidden={props.modal}
          />

          
          <br />
          <FrSelect
            value={data.fk_ori || ''}
            onChange={handleChange}
            name="fk_ori"
            id="fk_ori"
            label='Origem Contato *'
            data={comboOri}
            style={{ width: 300 }}
            disabled={disableEdit}
            hidden={props.modal}
          />

          <FrSelect
            value={data.fk_sub || ''}
            onChange={handleChange}
            name="fk_sub"
            id="fk_sub"
            label={'SubOrigem Contato' + (data.exige_suborigem == 'S' ? ' *' : '')}
            data={comboSub}
            style={{ width: 300 }}
            disabled={disableEdit}
            hidden={props.modal}
          />

          <div>
            <Dialog 
              aria-labelledby="simple-dialog-title" 
              open={showModalCliente} 
              fullWidth={true} 
              maxWidth={'lg'}
            >
              <ClientesModal 
                modal 
                setShowModalCliente={setShowModalCliente} 
                setNomeCli={setNomeCli} 
                setPk_Cli={setResponsavel} 
                responsavel
                setCriouResponsavel={setCriouResponsavel}
              />
            </Dialog>
          </div>

        </form>
        <div className="regButtonsDiv">
          {enableEdit === 'S' ?
            (<button onClick={handleSubmit}>Salvar</button>) : (<></>)}
          <button onClick={handleCancel}>{enableEdit === 'S' ? 'Cancelar' : 'Fechar'}</button>
        </div>
        {!props.modal ? <FooterDelphus /> : <></>}
      </div>
    </div>
  );
}

export default Clientes;
